import { createSlice } from '@reduxjs/toolkit';
type initialStateType = {
  open: boolean;
  type: any;
  message: string;
  customVisibleTime?:number;
};

const initialState: initialStateType = {
  open: false,
  type: '',
  message: '',
  customVisibleTime:0,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      return { ...state, ...action.payload , customVisibleTime: action?.payload?.customVisibleTime || 0 };
    },
    hideSnackbar: (state) => {
      return { ...state, open: false };
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
